<template>
    <b-row class="vh-100" align-v="center" >
        <b-col cols="12" md="8" offset-md="2" align-self="center">
            <b-row align-h="center">
                <b-col cols="12" align-self="center" style="text-align:center" class="mb-5">
                    <h3>{{ $t('invoicing.title') }}</h3>
                    <p>{{ $t('invoicing.description') }}</p>
                </b-col>

                <b-col cols="12" align-self="center" class="form">
                    <SettingsForm @success="success"/>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<style scoped>
.onboard {
    overflow-x: scroll;
}

.form {
    margin-bottom: 80px;
}
</style>

<script>
import OnboardingLayout from '@/components/integrations/OnboardingLayout.vue'
import SettingsForm from './Settings'

export default {
    components: {
        OnboardingLayout,
        SettingsForm
    },

    data: function() {
        return {}
    },

    i18n: {
        messages: {
            en_US: {
                invoicing: {
                    title: 'Invoicing',
                    description: 'In order to use invoicing functionality you will need to provide some informations.'
                }
            },

            sr: {
                invoicing: {
                    title: 'Fakturisanje',
                    description: 'Da biste koristili funkcionalnost fakturisanja, moraćete pružiti neke informacije.'
                }
            }
        }
    },

    methods: {
        success() {
            this.$emit('onboardingSuccess', 'integration', 'protokol-invoicing')
        }
    },

    mounted() {}
}
</script>